import React, { useState } from "react";
import PT from "prop-types";
import ReactDOM from "react-dom";
import {
  LightgalleryProvider,
  LightgalleryItem,
  withLightgallery,
  useLightgallery
} from "react-lightgallery";
//


const GROUP = [
  "/danci/d1.JPG",
  "/danci/d3.JPG",
  "/danci/d5.JPG",
  "/danci/d6.JPG",
  "/kravy/5.JPG",
  "/kravy/6.JPG",
  "/kravy/k1.JPG",
  "/kravy/k2.JPG",
  "/kravy/k7.JPG",
  "/ovce/o1.JPG",
  "/ovce/o2.JPG",
  "/ovce/o3.JPG",
  "/ovce/o4.JPG",
  "/ovce/o5.JPG",
  "/ovce/o6.JPG",
  "/vcely/v2.jpg",
  "/vcely/v4.jpg",
  "/vcely/v5.jpg",
  "/chata/ch1.jpg",
  "/chata/ch2.jpg",
  "/chata/ch3.jpg",
  "/kone/ko1.jpg",
  "/kone/ko2.jpg"
];

const PhotoItem = ({ image, thumb, group }) => (
  <div style={{ maxWidth: "350px", width: "max(40%,300px)", padding: "5px" }}>
    <LightgalleryItem group={group} src={image} thumb={thumb}>
      <img src={image} style={{ width: "100%" }} />
    </LightgalleryItem>
  </div>
);
PhotoItem.propTypes = {
  image: PT.string.isRequired,
  thumb: PT.string,
  group: PT.string.isRequired
};

export function Gallery() {
  return (
    <div className="content">
      <div>
        <LightgalleryProvider>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}

            className="gallery"
          >
            {GROUP.map((p, idx) => (
              <PhotoItem key={idx} image={p} group="group" />
            ))}
          </div>
        </LightgalleryProvider>
      </div>
    </div>
  );
}

export default Gallery;
